<template>
  <div class="pVodWrap modal" :class="{ open: timeFlag }">
    <div class="pVodBar">
      <p>{{ $t('product.liveProduct') }} ({{ this.prdtList.length }})</p>
      <button
        class="menuToggle"
        @click="vertiToggle"
        :class="{ verti: vertiMenu, hori: !vertiMenu }"
      ></button>

      <button @click="goBack" class="close" v-if="exit"></button>
    </div>

    <div class="pVodList" v-if="vertiMenu === false">
      <ul class="pVodListUl" :class="{ verti: vertiMenu, hori: !vertiMenu }">
        <li
          class="pVodListLi hori"
          v-for="list in prdtList"
          v-bind:key="list.broadcastProductSysId"
        >
          <button @click="chkSoldOut(list)">
            <div class="prdtListImg hori">
              <img :src="list.squareImageUrl || list.bigImageUrl" />
              <div class="isSoldOut" v-if="list.isDisplay === 0">
                <p>{{ $t('product.doNotBuyProduct') }}</p>
              </div>
              <!-- 이벤트기간 한정 히든처리 -->
              <!-- <div class="isSoldOut" v-else-if="list.isSoldout === 1">
                <p>{{ $t('product.onlyLive') }}</p>
              </div> -->
            </div>

            <div class="prdtListInfo hori">
              <!-- 이벤트기간 한정 히든처리 -->
              <!-- <div
              class="prdtListInfo hori"
              :class="{ soldOut: list.isSoldout === 1 }"
            > -->
              <p class="prdtInfoTitle">{{ list.name }}</p>
              <p class="prdtInfoBrand">{{ list.brandName }}</p>
              <div class="prdtInfoPrice hori">
                <p class="prdtPrice">
                  {{ ProductService.prdtPrice(list).value | makeComma
                  }}<span>{{ $t('global.unitMoney') }}</span>
                </p>
                <p
                  class="prdtDisCount"
                  v-if="ProductService.prdtPrice(list).discountRate > 0"
                >
                  {{ ProductService.prdtPrice(list).discountRate }}%
                </p>
                <p
                  class="prdtMarketMoney"
                  v-if="ProductService.prdtPrice(list).discountRate > 0"
                >
                  {{ list.marketPrice | makeComma }}
                </p>
              </div>
              <div
                class="prdtDelivery hori"
                v-if="list.isSoldout === 0 && list.deliveryPriceTypeCode === 1"
              >
                <span class="freeDl">{{ $t('mypage.deliveryFree') }}</span>
              </div>
            </div>
          </button>
        </li>
      </ul>
    </div>
    <div class="pVodList verti " v-if="vertiMenu === true" ref="trackWrapper">
      <ul
        class="pVodListUl verti"
        :style="{ width: 149 * prdtList.length + 12 + 'px' }"
        ref="track"
      >
        <li
          class="pVodListLi verti"
          v-for="list in prdtList"
          v-bind:key="list.broadcastProductSysId"
        >
          <button @click="chkSoldOut(list)">
            <div class="prdtListImg verti">
              <img :src="list.squareImageUrl || list.bigImageUrl" />
              <div class="isSoldOut" v-if="list.isDisplay === 0">
                <p>{{ $t('product.doNotBuyProduct') }}</p>
              </div>
              <!-- 이벤트기간 한정 히든처리 -->
              <!-- <div class="isSoldOut" v-else-if="list.isSoldout === 1">
                <p>{{ $t('product.onlyLive') }}</p>
              </div> -->
            </div>

            <!-- 이벤트기간 한정 히든처리 -->
            <!-- <div
              class="prdtListInfo verti"
              :class="{ soldOut: list.isSoldout === 1 }"
            > -->
            <div class="prdtListInfo verti">
              <div class="prdtInfoPrice verti">
                <p
                  class="prdtDisCount verti"
                  v-if="ProductService.prdtPrice(list).discountRate > 0"
                >
                  {{ ProductService.prdtPrice(list).discountRate }}%
                </p>
                <p
                  class="prdtMarketMoney verti"
                  v-if="ProductService.prdtPrice(list).discountRate > 0"
                >
                  {{ list.marketPrice | makeComma }}
                </p>
              </div>
              <p class="prdtPrice verti">
                {{ ProductService.prdtPrice(list).value | makeComma
                }}<span>{{ $t('global.unitMoney') }}</span>
              </p>
              <p class="prdtInfoTitle verti">{{ list.name }}</p>
              <p class="prdtInfoBrand verti">{{ list.brandName }}</p>

              <div class="prdtDelivery verti">
                <span
                  v-if="
                    list.isSoldout === 0 && list.deliveryPriceTypeCode === 1
                  "
                  >{{ $t('mypage.deliveryFree') }}</span
                >
                <span
                  v-if="ProductService.prdtPrice(list).isLiveCheck"
                  class="liveBenefit"
                  >{{ $t('product.liveBenefit') }}</span
                >
              </div>
            </div>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getBroadCastPrdts } from '@/api'
import { AppBridge } from '@/assets/js/common.js'
import VerticalScrollMouseEvent from '@/components/mixins/VerticalScrollMouseEvent'

export default {
  props: [
    'exit',
    'productList',
    'showPrdtModal',
    'type',
    'bcScheduleSysId',
    'brdCSysId',
    'brdPrdtCnt',
    'ProductService'
  ],

  components: {},
  mixins: [VerticalScrollMouseEvent],
  data() {
    return {
      list: [],
      vertiMenu: true,
      prdtCol: true,
      prdtList: [],
      timeFlag: false,
      init: false
    }
  },

  computed: {
    ...mapGetters('variableStore', ['isIos'])
  },

  watch: {
    productList: {
      handler(ol, nl) {
        if (ol !== nl) {
          this.goBack()
          this.prdtList = this.productList
        }
      }
    },
    showPrdtModal: {
      handler() {
        this.timeFlag = this.showPrdtModal

        if (this.isIos && !this.init) {
          this.vertiMenu = !this.vertiMenu
          setTimeout(() => {
            this.vertiMenu = !this.vertiMenu
            this.init = true
          }, 10)
        }
      }
    }
  },

  async created() {
    window.setVodPrdtCol = this.setVodPrdtCol

    AppBridge.get('vodPrdtCol')

    if (!this.productList) {
      try {
        let res = await getBroadCastPrdts(this.brdCSysId, 0, this.brdPrdtCnt)
        console.log(res)
        if (res.data.jsonData.resultCode === '0001') {
          if (res.data.jsonData.broadcastPrdts) {
            res.data.jsonData.broadcastPrdts.forEach((x) => {
              this.prdtList.push(x)
            })
          }
        }
      } catch (err) {
        console.log(err)
      }
    } else {
      this.prdtList = this.productList
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.timeFlag = this.showPrdtModal
    })
    this._mixinInit(this.$refs.trackWrapper)
  },
  methods: {
    goBack() {
      this.$emit('closeModal', false)
    },

    delevery(code, debit, prepay, debitFree, prepayFree) {
      if (code === 1) {
        return this.$t('mypage.deliveryFree')
      } else {
        if (code === 2) {
          if (debit > 0 && debitFree > 0) {
            return this.$t('product.partFree')
          } else {
            return this.$t('mypage.deliveryAmount')
          }
        } else if (code === 3) {
          if (prepay > 0 && prepayFree > 0) {
            return this.$t('product.partFree')
          } else {
            return this.$t('mypage.deliveryAmount')
          }
        }
      }
    },

    deleveryFree(code, debit, prepay, debitFree, prepayFree) {
      if (code === 1) {
        return ''
      } else {
        if (code === 2) {
          if (debitFree > 0) {
            return debitFree
          } else {
            return debit
          }
        } else if (code === 3) {
          if (prepayFree > 0) {
            return prepayFree
          } else {
            return prepay
          }
        }
      }
    },

    chkSoldOut(item) {
      if(this.mixinClicked) {
        return false
      }
      if (item.isDisplay === 0) {
        return alert(this.$t('product.cannotBuyProduct'))
      }
      // 이벤트기간 한정 히든처리
      // if (item.isSoldout === 1) {
      //   alert(this.$t('product.canBuyInbroadcast'))
      // }

      // vod를 pip모드로 변환
      if (this.productList) {
        let param = {
          pipMode: true
        }
        console.log('pip모드 변경. 라우터')
        window.pastVod(param)
        AppBridge.send('VodScreenStatus', { value: param.pipMode }, true)
      }

      document.body.style.overflow = 'visible'
      document.body.style.height = '100%'

      this.$emit('closeModal', false)

      let _this = this
      setTimeout(function () {
        if (_this.type === 'vod') {
          if (item.isSoldout === 1) {
            _this.$router.push({
              path: '/Product/' + item.prdtSysId,
              query: { liveFlag: true }
            })
          } else {
            _this.$router.push('/Product/' + item.prdtSysId)
          }
        } else {
          _this.$router.push(
            '/Product/' + item.prdtSysId + '/live/' + _this.bcScheduleSysId
          )
        }
      }, 300)
    },

    vertiToggle() {
      this.vertiMenu = !this.vertiMenu

      if (this.vertiMenu === true) {
        AppBridge.set('vodPrdtCol', JSON.stringify({ value: true }))
      } else {
        AppBridge.set('vodPrdtCol', JSON.stringify({ value: false }))
      }
    },

    setVodPrdtCol(obj) {
      console.log(obj)
      let type
      if (obj !== '' && obj.indexOf('value') > -1) {
        if (JSON.parse(obj).value !== '') {
          type = JSON.parse(obj).value
        }
      }
      this.vertiMenu = type
    },
  }
}
</script>
<style lang="scss">
.pVodWrap.modal {
  position: fixed;
  width: 100%;
  height: 52%;
  bottom: 0;
  left: 0;
  z-index: 130;
  text-align: center;
  background-color: #fff;
  transform: translateY(100%);
  box-shadow: 0 3px 5px 1px rgb(0, 0, 0, 0.2);
  overflow-y: initial;
  border-radius: 10px 10px 0 0;
}

.pVodWrap.modal.open {
  transition: all 0.5s ease-in-out;
  transform: translateY(0%);
}

.pVodWrap.modal .pVodBar {
  position: relative;
  z-index: 100;
  height: 15%;
  border-bottom: 1px solid #ededed;
  padding-bottom: 6px;
  margin: 0 12px;
}

.pVodWrap.modal .pVodBar p {
  position: absolute;
  top: 16px;
  left: 12px;
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.5px;
  text-align: left;
  color: #141414;
}

.pVodWrap.modal .pVodBar .menuToggle.verti {
  position: absolute;
  top: 17px;
  right: 52px;
  display: inline-block;
  width: 24px;
  height: 24px;
  object-fit: contain;
  background: url('../../assets/img/ico/icon_as-vertical.png') 0 0 / 100% auto
    no-repeat;
}

.pVodWrap.modal .pVodBar .menuToggle.hori {
  position: absolute;
  top: 17px;
  right: 52px;
  display: inline-block;
  width: 24px;
  height: 24px;
  object-fit: contain;
  background: url('../../assets/img/ico/icon_as_horizontal.png') 0 0 / 100% auto
    no-repeat;
}

.pVodWrap.modal .pVodBar .close {
  position: absolute;
  top: 17px;
  right: 12px;
  display: inline-block;
  width: 24px;
  height: 24px;
  object-fit: contain;
  background: url('../../assets/img/ico/icon_close_bk.png') 0 0 / 100% auto
    no-repeat;
}

.pVodWrap.modal .pVodList {
  position: relative;
  z-index: 100;
  height: 80%;
  overflow-y: auto;
}

.pVodWrap.modal .pVodList .pVodListUl.hori {
  height: auto;
  margin-left: 12px;
}
.pVodWrap.modal .pVodList .pVodListUl.verti {
  height: 100%;
}

.pVodWrap.modal .pVodList .pVodListLi.verti:first-child {
  content: '';
  margin-left: 12px;
}

.pVodWrap.modal .pVodList .pVodListLi.hori {
  width: 100%;
  height: 100%;
  position: relative;
  display: inline-block;
}

.pVodWrap.modal .pVodList .pVodListLi .prdtListInfo.hori.soldOut {
  background-color: rgba(255, 255, 255, 0.6);
  opacity: 0.3;
}

.pVodWrap.modal .pVodList .pVodListLi button {
  background-color: rgba(255, 255, 255, 0.6);
  width: 100%;
  height: 100%;
  display: block;
  box-sizing: border-box;
  /* overflow: hidden; */
}
.pVodWrap.modal .pVodList .pVodListLi.hori .prdtListImg.hori {
  float: left;
  width: 96px;
  height: 96px;
  box-sizing: border-box;
  border: 1px solid #ededed;
  border-radius: 4px;
  margin-top: 12px;
}

.pVodWrap.modal .pVodList .pVodListLi.hori .prdtListImg img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #fff;
}

.pVodWrap.modal .pVodList .pVodListLi.hori .prdtListImg.hori .isSoldOut {
  position: relative;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 0px 0px 4px 4px;
  width: 100%;
  height: 34px;
  bottom: 38px;
}

.pVodWrap.modal .pVodList .pVodListLi.hori .prdtListImg.hori .isSoldOut p {
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.48px;
  text-align: center;
  color: #ffffff;
  padding-top: 6px;
}

.pVodWrap.modal .pVodList .pVodListLi.hori .prdtListInfo.hori {
  float: left;
  top: 10px;
  left: 100px;
  text-align: left;
  margin-top: 12px;
  margin-left: 8px;
  box-sizing: border-box;
  width: calc(100% - 105px);
}

.pVodWrap.modal .pVodList .pVodListLi .prdtListInfo.hori .prdtInfoTitle {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.64;
  text-align: left;
  color: #191919;
}
.pVodWrap.modal .pVodList .pVodListLi .prdtListInfo.hori .prdtInfoBrand {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.48px;
  text-align: left;
  color: #999999;
  margin-bottom: 4px;
}
.pVodWrap.modal .pVodList .pVodListLi .prdtListInfo.hori .prdtInfoPrice.hori {
  display: inline;
  padding: 2px 0;
}
.prdtListInfo.hori .prdtInfoPrice .prdtDisCount {
  display: inline;
  font-size: 15px;
  padding-right: 5px;
  font-weight: bold;
  color: $main-color;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.56px;
  text-align: right;
}

.prdtListInfo .prdtInfoPrice.hori .prdtPrice {
  display: inline;
  font-size: 18px;
  padding-right: 5px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.72px;
  text-align: right;
  color: #191919;
}

.prdtListInfo .prdtInfoPrice.hori .prdtPrice span {
  width: 11px;
  height: 18px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.48px;
  text-align: left;
  color: #191919;
}

.prdtListInfo .prdtInfoPrice .prdtMarketMoney {
  display: inline;
  color: #999999;
  text-decoration-line: line-through;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.58px;
  text-align: right;
}

.prdtListInfo .isSoldOut {
  display: inline;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: $main-color;
}

.pVodWrap.modal .bttm {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 42px;
  background-color: #f7f7f7;
}

.pVodWrap.modal .bttm p {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.56px;
  text-align: center;
  color: #505050;
  vertical-align: middle;
  text-align: center;
  padding-top: 10px;
}

.pVodWrap.modal .pVodList.verti {
  height: 90%;
  overflow-x: auto;
  overflow-y: hidden;
}

.pVodWrap.modal .pVodList.verti .pVodListUl {
  list-style: none;
  display: block;
  clear: both;
}
.pVodWrap.modal .pVodList.verti .pVodListLi {
  position: relative;
  float: left;
  width: auto;
  height: 100%;
  padding-right: 12px;
  /* display: inline-block; */
}

.pVodList.verti .pVodListLi.verti .prdtListInfo.verti.soldOut {
  background-color: rgba(255, 255, 255, 0.6);
  opacity: 0.3;
}

.pVodWrap.modal .pVodList.verti .pVodListLi button {
  background-color: rgba(255, 255, 255, 0.6);
  width: 100%;
  display: block;
  box-sizing: border-box;
  overflow: hidden;
}

.pVodWrap.modal .pVodList.verti .pVodListLi .prdtListImg {
  width: 136px;
  height: 136px;
  box-sizing: border-box;
  margin-bottom: 8px;
  border: 1px solid #ededed;
  border-radius: 4px;
  margin-top: 12px;
}

.pVodWrap.modal .pVodList.verti .pVodListLi .prdtListImg img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #fff;
}

.pVodList.verti .pVodListLi .prdtListImg.verti .isSoldOut {
  position: relative;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 0px 0px 4px 4px;
  width: 100%;
  height: 34px;
  bottom: 38px;
}

.pVodList.verti .pVodListLi .prdtListImg.verti .isSoldOut p {
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.48px;
  text-align: center;
  color: #ffffff;
  vertical-align: middle;
  padding-top: 7px;
}

.pVodWrap.modal .pVodList.verti .pVodListLi .prdtListInfo {
  top: 2px;
  text-align: left;
  box-sizing: border-box;
  width: 137px;
  height: 50%;
  float: none;
  padding: 0;
}

.pVodWrap.modal .pVodList.verti .pVodListLi .prdtListInfo .prdtInfoTitle {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.64px;
  text-align: left;
  color: #111111;
  height: 24px;
}
.pVodWrap.modal .pVodList.verti .pVodListLi .prdtListInfo .prdtInfoBrand {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.48px;
  text-align: left;
  color: #999999;
  height: 18px;
}

.prdtListInfo.verti .prdtInfoPrice {
  height: 19px;
}

.prdtListInfo.verti .prdtInfoPrice .prdtDisCount {
  display: inline;
  font-weight: bold;
  color: $main-color;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.56px;
  text-align: right;
  font-size: 14px;
}

.prdtListInfo.verti .prdtInfoPrice .prdtMarketMoney {
  display: inline;
  color: #aaaaaa;
  text-decoration-line: line-through;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.48px;
  text-align: right;
  color: #aaaaaa;
  font-size: 12px;
}

.prdtListInfo.verti .prdtPrice.verti {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.48px;
  color: #191919;
}
.prdtListInfo.verti .prdtPrice span {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.48px;
  text-align: left;
  color: #191919;
}

.prdtListInfo .prdtDelivery {
  display: block;
  margin-top: 8px;
  margin-bottom: 12px;
}

.prdtListInfo .prdtDelivery span {
  display: inline-block;
  margin: 4px;
  padding: 1px 3px;
  border: 1px solid #767676;
  border-radius: 4px;
  font-size: 12px;
  color: #767676;
}

.prdtListInfo .prdtDelivery .liveBenefit {
  color: #e73656;
  border: 1px solid #e73656;
}

.prdtListInfo.verti .isSoldOut {
  display: inline;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: $main-color;
}

.pVodWrap.modal .backPannel {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
}
</style>